import Vue from "vue";
import { functions, api } from "@/firebase.js";

export default {
  state: {
    clientes: 1,
    pruebas: 1,
    tests: 1,
    usuarios: 1,
    emails: {
      cantidad: 0,
      fecha: new Date()
    }
  },
  mutations: {
    setFolios(state, folios) {
      state.clientes = folios.clientes;
      state.pruebas = folios.pruebas;
      state.tests = folios.tests;
      state.usuarios = folios.usuarios;
      state.emails = folios.emails;
    }
  },
  actions: {
    ConsultarFolios(context, folios) {
      api("getFolios")({
        data: {}
      })
        .then(response => {
          context.commit("setFolios", response.data);
        })
        .catch(error => {
          console.log("Error al consultar los folios", error);
        });
    }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/modules/folios.js